<template>
  <div class="new-alert-entry-component screen">
    <ModalHeader
      v-if="$isMobile"
      :config="{
        type: 'back',
        screenName: 'manage-alerts',
        navigateBack: navigateBack,
        title: '',
        subTitle: '',
      }"
      @close="beforeClose()"
    />
    <div class="header-band" v-else>
      <button class="back-button" @click="goBack()">
        <img src="@/assets/images/backArrow.svg" alt="back" />
        Back
      </button>
      <div class="divider"></div>
      <div class="heading">New alert type</div>
      <CloseButton variant="light" inline @click="beforeClose()" />
    </div>
    <div class="heading" v-if="$isMobile">New alert type</div>
    <div class="panel">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Speeding')">
              <img src="~@/assets/images/trips/over-speeding.svg" width="34" height="35" />
              <div class="name">Speeding</div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Braking')">
              <img src="../../assets/images/trips/harsh-braking.svg" width="34" height="35" />
              <div class="name">Harsh braking</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Acceleration')">
              <img src="~@/assets/images/trips/harsh-acceleration.svg" width="34" height="35" />
              <div class="name">Acceleration</div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Impacts')">
              <img src="~@/assets/images/trips/impacts.svg" width="34" height="35" />
              <div class="name">Impacts</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Cornering')">
              <img src="~@/assets/images/trips/harsh-cornering.svg" width="34" height="35" />
              <div class="name">Cornering</div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Lane-Change')">
              <img src="~@/assets/images/trips/lane-changing.svg" width="34" height="35" />
              <div class="name">Lane-change</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Geo-Fencing')">
              <img src="~@/assets/images/trips/geo-zone.svg" width="34" height="35" />
              <div class="name">Geo zone</div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-0 mb-2">
            <div class="item" @click="open('Time Rule')">
              <img src="~@/assets/images/trips/time-rule.svg" width="34" height="35" />
              <div class="name">Time rule</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.new-alert-entry-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: $brand-color-1;
    padding: 12px 30px;
    margin: -20px -30px 25px -30px;
    color: #fff;
    position: relative;
    font-size: 1.1875rem;

    .back-button {
      display: flex;
      align-items: center;
      background: none;
      color: #fff;
      padding: 0;
      border: none;
      font-size: 1.1875rem;
      font-weight: 300;

      img {
        margin-right: 8px;
      }

      &:focus {
        outline: none;
      }
    }

    .divider {
      width: 1px;
      height: 20px;
      background-color: #fff;
      margin: 0 15px;

      &.divider-wide {
        margin: 0 40px 0 15px;
      }
    }

    .vehicle-picker-container {
      padding: 0;
    }

    .heading {
      font-size: 1.1875rem;
      font-weight: 600;
      color: #fff;
    }
  }

  > .heading {
    font-weight: 600;
    font-size: 1.1875rem;
    padding: 0px 20px 10px;
  }

  .panel {
    background: $brand-color-4;
    padding: 15px 20px;

    .item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: bold;

      &:hover {
        cursor: pointer;
      }

      img {
        margin-right: 10px;
      }

      .name {
        text-transform: none;
      }
    }
  }
}
</style>

<script>
import { modalService } from "@/services";
import CloseButton from "@/components/CloseButton";
import VehiclePickerMenu from "@/components/screens/VehiclePickerMenu";
import ModalHeader from "@/components/screens/ModalHeader";

export default {
  name: "NewAlertEntry",
  components: {
    CloseButton,
    VehiclePickerMenu,
    ModalHeader,
  },
  data() {
    return {
      navigateBack: false,
    };
  },
  methods: {
    beforeClose() {
      this.$emit("close");
    },
    goBack() {
      if (this.$isMobile) {
        this.$emit("close");
      } else {
        modalService.showModal(this, "manage-alerts");
      }
    },
    open(alertType) {
      modalService.showModal(this, "new-alert", { type: alertType });
    },
  },
};
</script>